/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InProgressCoverage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function InProgressCoverage({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/OrthodonticCoverage/OrthoCoverage/Content/InProgressCoverage",
  onChange
  
}) {
let globalCurrentLocationPermissionsHasPatientInsuranceEditValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'current_location.permissions.has_patient_insurance_edit',
format: fromFormat.not,
})
let planDetailsInprogressValueData = fromData.useDataValue({ viewPath,
context: 'plan_details',
path: 'inprogress',
})
let planDetailsInprogressChangeData = fromData.useDataChange({ viewPath,
context: 'plan_details',
path: 'inprogress',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="global.current_location.permissions.has_patient_insurance_edit"
 format="/Data/format.js not"
 disabled={globalCurrentLocationPermissionsHasPatientInsuranceEditValueData}
 data="plan_details.inprogress"
 value={planDetailsInprogressValueData}
 onChange={planDetailsInprogressChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="In-Progress Coverage"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}